import { TextField, TextFieldProps } from "@mui/material";
import { useEffect, useState } from "react";

type BlurChangeInputProps<Variant extends "filled" | "outlined" | "standard" = "outlined"> = TextFieldProps<Variant> & {
  value: string,
  onBlurChange: (value: string) => void,
};

export default function BlurChangeInput({ 
  value, 
  onBlurChange, 
  ...props
}: BlurChangeInputProps) {
  const [inputValue, setInputValue] = useState<string>(value);

  useEffect(() => {
    if (value !== inputValue) {
      setInputValue(value);
    }
  }, [value]);

  function onBlur(_event: React.FocusEvent<HTMLInputElement>) {
    onBlurChange(inputValue);
  }

  return (
    <TextField
      {...props}
      value={inputValue}
      onChange={(e) => { setInputValue(e.target.value) }}
      onBlur={onBlur}
    />
  );
}
